import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import Logo from '../assets/logo1.jpeg';
import 'animate.css';

const AdminHeader = () => {
const [showNav, setShowNav] = useState(false);
const navigate = useNavigate();

  const handleLogout = () => {
    // localStorage.removeItem('username');
    localStorage.removeItem('isLoggedIn', 'true');
    navigate('/');
    window.location.reload();
}

  return (
    <>
<header className='py-2 sticky-top bg-white'>
    <div className='container d-flex justify-content-between'>

<img src={Logo} alt='Logo' className='header-img' />
<div className='align-content-center d-lg-block d-none'>
    <NavLink className='nav-text' activeClassName='active' to='/dashboard'>Dashboard</NavLink>
    <NavLink className='nav-text' activeClassName='active' to='/bookings'>Bookings</NavLink>
    <NavLink className='nav-text' activeClassName='active' to='/site-enquiry'>Site Enquiry</NavLink>
    {/* <NavLink className='nav-text' activeClassName='active' to='/tour-packages'>Tour Packages</NavLink>
    <NavLink className='nav-text' activeClassName='active' to='/contact'>Contact</NavLink> */}
</div>

<span className='me-3 d-lg-none d-block align-content-center' onClick={() => setShowNav(true)}><i class="fa-solid fa-bars fs-5"></i></span>
<div className='align-content-center'>
<button className='nav-btn' onClick={handleLogout}>Log Out<i class="fa-solid fa-power-off ps-2"></i></button></div>

    </div>
</header>

{showNav && (
  <>
  <div className='sidebar-area animate__animated animate__fadeInDown'>
<span onClick={() => setShowNav(false)} className='float-end'><i class="fa-solid fa-circle-xmark fs-5"></i></span><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName='active' to='/dashboard'>Dashboard</NavLink><br /><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName='active' to='/bookings'>Bookings</NavLink><br /><br />
    {/* <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName='active' to='/gallery'>Gallery</NavLink><br /><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName='active' to='/tour-packages'>Tour Packages</NavLink><br /><br /> */}
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName='active' to='/site-enquiry'>Site Enquiry</NavLink>

  </div>
  </>
)}
    </>
  )
}

export default AdminHeader
